<div class="kt-portlet">
    <div class="kt-portlet__head">
        <div class="kt-portlet__head-label">
            <h3 class="kt-portlet__head-title">
                {{volunteerCategory.name}} Rolleri
            </h3>
        </div>
        <div class="kt-portlet__head-toolbar">
            <div class="kt-portlet__head-actions">
                <a routerLink="/volunteer-role-type/new" class="btn btn-success btn-pill btn-sm">
                    <i class="fa fa-plus marr10"></i>Yeni Ekle
                </a>

            </div>
        </div>
    </div>
    <div class="kt-portlet__body">
        <div class="kt-section">
            <div class="kt-section__content">

                <div class="kt-pagination  kt-pagination--brand">
                    <ul class="kt-pagination__links">
                    </ul>
                </div>
                <div class="table-responsive">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>Rol</th>
                                <th>Bağlı olduğu rol</th>
                                <th>Gönüllü kategorisi</th>
                                <th>İşlemler</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let volunteerRoleType of volunteerRoleTypes;">
                                <td>{{volunteerRoleType.name}}</td>
                                <td>{{getMainRoleName(volunteerRoleType.mainRoleTypeId)}}</td>
                                <td>{{getVolunteerCategoryName(volunteerRoleType.volunteerCategoryId)}}</td>
                                <td>
                                    <button class="btn btn-success mr-2"
                                        [routerLink]="['/volunteer-role-type/detail/'+volunteerRoleType.id]"><i
                                        class="fa fa-edit"></i>Düzenle</button>
                                    <button class="btn btn-danger mr-2" (click)="deleteVolunteerRoleType(volunteerRoleType.id, volunteerRoleType.name)"><i
                                            class="fa fa-trash"></i>Sil</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
